import { type ReactNode, Suspense } from 'react';

import { Loader2 } from 'lucide-react';

function PageLoader() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading page"
      style={{
        display: 'flex',
        height: '100%',
        minHeight: '400px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '12px',
        color: '#64748b',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <Loader2 className="animate-spin" size={32} color="#3b82f6" />
      <span style={{ fontSize: '14px', fontWeight: 500 }}>Loading…</span>
    </div>
  );
}

export function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}
